import { publicImgs } from "../assets/media/public";

export function preloadImages(srcArray) {
    return Promise.all(
        srcArray.map(src => 
            new Promise((resolve) => {
                const img = new window.Image();
                img.src = src;
                img.onload = img.onerror = resolve;
            })
        )
    );
};

export function preloadJSON(urlArray) {
    return Promise.all(
        urlArray.map(url => 
            fetch(url)
                .then(res => res.json())
                .catch(() => null)
        )
    );
};

export function preloadPublicImages() {
    return Promise.all(
        publicImgs.map(src =>
            new Promise((resolve) => {
                const img = new window.Image();
                img.src = src;
                img.onload = img.onerror = resolve;
            })
        )
    );
};